export default __webpack_public_path__ + "static/105-b6a5761652c19a12f7638ae3306e81d7.jpg";